// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EAP6","right":"styles_right__1bDUL"};